import { action, makeObservable, observable, reaction } from 'mobx';
import { RootStore } from '@store';
import { SoundInGame, UtilsLocalStorage } from './localStorage';
import { Howl } from 'howler';

export class SoundService {
    @observable isSound = false;
    private audioInstance: Howl | null = null;

    constructor(private rootStore: RootStore) {
        makeObservable(this);
        this.getIsSoundValueOnInitialization();
        this.subscribeForIsSound();
    }

    @action
    public playWithoutSound(val: boolean) {
        this.isSound = val;
    }

    private createInstanceAudio(audioB64Value: string): void {
        this.audioInstance = new Howl({
            src: [`data:audio/mpeg;base64,${audioB64Value}`],
            autoplay: true,
            mute: !this.isSound,
        });
    }

    @action
    private subscribeForIsSound() {
        reaction(
            () => this.isSound,
            () => {
                if (this.audioInstance) {
                    this.audioInstance.mute(!this.isSound);
                }
            },
        );
    }

    private currentAudioPlay(): void {
        if (this.audioInstance) {
            this.audioInstance.play();
        }
    }

    public playSoundTik(sound: string): void {
        this.createInstanceAudio(sound);
        this.currentAudioPlay();
    }

    public playSoundBet(sound: string): void {
        this.createInstanceAudio(sound);
        this.currentAudioPlay();
    }

    public playSoundWinning(sound: string): void {
        this.createInstanceAudio(sound);
        this.currentAudioPlay();
    }

    public playSoundDeckCard(sound: string): void {
        this.createInstanceAudio(sound);
        this.currentAudioPlay();
    }

    public playSoundDoubleRolling(sound: string): void {
        this.createInstanceAudio(sound);
        this.currentAudioPlay();
    }

    public playSoundTowerCorrectCell(sound: string): void {
        this.createInstanceAudio(sound);
        this.currentAudioPlay();
    }

    public playSoundTowerIncorrectCell(sound: string): void {
        this.createInstanceAudio(sound);
        this.currentAudioPlay();
    }

    public playSoundRocketExplosion(sound: string): void {
        this.createInstanceAudio(sound);
    }

    public playSoundCryptosWinning(sound: string): void {
        this.createInstanceAudio(sound);
        this.currentAudioPlay();
    }

    public playSoundRoundStart(sound: string, time: number): void {
        const startedAt = Date.now();
        const audio = new Howl({
            src: [`data:audio/mpeg;base64,${sound}`],
            mute: !this.isSound,
            onload: () => {
                audio.seek(time + (Date.now() - startedAt) / 1000);
                audio.play();
            },
        });

        this.audioInstance = audio;
    }
    public playSoundDiverStart(sound: string): void {
        this.createInstanceAudio(sound);
        this.currentAudioPlay();
    }
    public playSoundDiverFinis(sound: string): void {
        this.createInstanceAudio(sound);
        this.currentAudioPlay();
    }

    @action
    private getIsSoundValueOnInitialization() {
        if (UtilsLocalStorage.soundInGame) {
            this.isSound = UtilsLocalStorage.soundInGame === SoundInGame.ON ? true : false;
        }
    }
}
